<div class="layout-ParentDiv innerDiv">
	<div class="layout-dashboard" [ngClass]="hide ? 'responsiveHide-column' : 'responsiveShow-column'">
		<div class="mainDivHeader">
			<div class="leftdiv">
				<h4>Featured this Week Management <span class="badge">{{featuredThisWeekData ?
						featuredThisWeekData.length : 0 }}</span></h4>
			</div>
			<div class="rightDiv">
				<button class="exportBTn" (click)="exportExcel()"> <span><img
							src="../../../assets/images/backend-image/header/exportIcon.svg" alt=""></span>
					Export</button>
				<button class="addBTn" (click)="addNewFeaturedThisWeek()"> <span><img
							src="../../../assets/images/backend-image/header/plus.svg" alt=""></span> Add Featured this
					week</button>
			</div>
		</div>
		<div class="mainDivBody">
			<div class="date-filterDiv">
				<ul class="filtersList">
					<li>
						<p-dropdown inputId="searchfield" [options]="searchBy" [(ngModel)]="searchby"
							placeholder="Select Field" optionLabel="label"></p-dropdown>
					</li>
					<li>
						<p-calendar appendTo="body" monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
							[(ngModel)]="startDate" class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy"
							placeholder="From: dd / mm / yy" [showIcon]="true"></p-calendar>
					</li>
					<li>
						<p-calendar appendTo="body" monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
							[(ngModel)]="endDate" class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy"
							placeholder="To: dd / mm / yy" [showIcon]="true"></p-calendar>
					</li>
					<li>
						<button (click)="loadFeaturedThisWeekList(lastTableLazyLoadEvent)" class="searchFilterBtn">
							<img src="../../../assets/images/backend-image/common-images/search.svg" alt="">
						</button>
					</li>
					<li>
						<button (click)="clear()" class="clearFilterBtn">
							<img src="../../../assets/images/backend-image/common-images/delete.svg" alt="">
							<span>Clear All</span>
						</button>
					</li>
				</ul>
			</div>
			<div class="maintableDiv">
				<div class="tableParanet">
					<p-table class="expandable" #dt [value]="featuredThisWeekData" [paginator]="true" [rows]="10"
						[lazy]="true" scrollHeight="auto" scrollDirection="both"
						(onLazyLoad)="loadFeaturedThisWeekList($event)" [totalRecords]="totalFeaturedThisWeekDataCount"
						[loading]="loading" [rowsPerPageOptions]="paginationOption"
						styleClass="p-datatable-gridlines p-datatable-striped w-100">
						<ng-template pTemplate="header">
							<tr>
								<th pSortableColumn="title" class="col-180 titleTD">
									<div class="p-d-flex p-jc-between p-ai-center">
										Title
										<p-sortIcon field="title"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="description" class="col-180 titleTD">
									<div class="p-d-flex p-jc-between p-ai-center">
										Description
										<p-sortIcon field="description"></p-sortIcon>
									</div>
								</th>
								<th class="viewBtnTd">
									<div class="p-d-flex p-jc-between p-ai-center">
										Photo
									</div>
								</th>
								<th pSortableColumn="link" class="col-180 createdDateTD">
									<div class="p-d-flex p-jc-between p-ai-center">
										Link
										<p-sortIcon field="link"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="status" class="statusTD">
									<div class="col-150 p-d-flex p-jc-between p-ai-center">
										Status
										<p-sortIcon field="status"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="created_at">
									<div class="p-d-flex p-jc-between p-ai-center">
										Date of Creation
										<p-sortIcon field="created_at"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="createdBy" class="col-180 CreatedByTD">
									<div class="p-d-flex p-jc-between p-ai-center">
										Created By
										<p-sortIcon field="createdBy"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="updated_at" class="col-180 updatedTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<div class="p-d-flex p-jc-between p-ai-center">
										Last Modified On
										<p-sortIcon field="updated_at"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="updatedBy" class="col-180 ModifiedbyTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<div class="p-d-flex p-jc-between p-ai-center">
										Modified By
										<p-sortIcon field="updatedBy"></p-sortIcon>
									</div>
								</th>
								<th class="col-180 actionTD p-element p-frozen-column">Action</th>
							</tr>
							<tr>
								<th [ngSwitch]="title" class="titleTD">
									<input pInputText type="text"
										(keyup.enter)="dt.filter($event.target.value, 'title', 'contains')"
										style="width: 100%;"
										[value]="dt.filters['title'] ? dt.filters['title'].value : ''" [(ngModel)]="title"/>
								</th>
								<th [ngSwitch]="description" class="titleTD">
									<input pInputText type="text"
										(keyup.enter)="dt.filter($event.target.value, 'description', 'contains')"
										style="width: 100%;"
										[value]="dt.filters['description'] ? dt.filters['description'].value : ''" [(ngModel)]="description"/>
								</th>
								<th class="viewBtnTd">
								</th>
								<th [ngSwitch]="link">
								</th>
								<th [ngSwitch]="status" class="statusTD">
									<p-dropdown #pDropDownId [options]="statuses"
										(onChange)="dt.filter($event.value, 'status', 'equals')"
										styleClass="p-column-filter" placeholder="Select Status" [showClear]="true">
										<ng-template let-option pTemplate="item">
											<span
												[class]="'customer-badge status-' + option.value">{{option.label}}</span>
										</ng-template>
									</p-dropdown>
								</th>
								<th [ngSwitch]="created_at">
									<p-calendar appendTo="body" monthNavigator="true" yearNavigator="true" yearRange="2022:2050" (onSelect)="dt.filter($event,'created_at', 'dateIs')" [(ngModel)]="calvalue"
                                                class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true"></p-calendar>
								</th>
								<th [ngSwitch]="createdBy">
									<input pInputText type="text"
										(keyup.enter)="dt.filter($event.target.value, 'createdBy', 'contains')"
										style="width: 100%;"
										[value]="dt.filters['createdBy'] ? dt.filters['createdBy'].value : ''" [(ngModel)]="createdBy"/>
								</th>
								<th [ngSwitch]="updated_at" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<p-calendar appendTo="body" monthNavigator="true" yearNavigator="true" yearRange="2022:2050" (onSelect)="dt.filter($event,'updated_at', 'dateIs')" [(ngModel)]="ucalvalue"
												class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true"></p-calendar>
								</th>
								<th [ngSwitch]="updatedBy" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<input pInputText type="text"
										(keyup.enter)="dt.filter($event.target.value, 'updatedBy', 'contains')"
										style="width: 100%;"
										[value]="dt.filters['updatedBy'] ? dt.filters['updatedBy'].value : ''" [(ngModel)]="updatedBy"/>
								</th>

								<th class="p-element p-frozen-column">
									<div class="buttonColumn">
										<button class="addBTn" (click)="addColumns()"
											[ngClass]="hide ? 'show-column ' : 'hide-column'">
											+ Show Column
										</button>
										<button class="removeBTn" (click)="removeColumns()"
											[ngClass]="hide ? 'hide-column' : 'show-column '">
											- Hide Column
										</button>

									</div>
								</th>
							</tr>
						</ng-template>
						<ng-template pTemplate="body" let-featuredThisWeekData let-rowIndex="rowIndex">
							<tr>
								<td class="col-180 titleTD">

									<span class="textOverFlow1" [pTooltip]="featuredThisWeekData.title"
										severity="secondary" tooltipPosition="bottom">
										{{featuredThisWeekData.title}}

									</span>
									<ng-template #[featuredThisWeekData.title]>
										<div class="flex align-items-center">
											<span> {{featuredThisWeekData.title}}</span>
										</div>
									</ng-template>
								</td>
								<td class="col-180 titleTD">

									<span class="textOverFlow1" [pTooltip]="featuredThisWeekData.description"
										severity="secondary" tooltipPosition="bottom">
										{{featuredThisWeekData.description}}

									</span>
									<ng-template #[featuredThisWeekData.description]>
										<div class="flex align-items-center">
											<span> {{featuredThisWeekData.description}}</span>
										</div>
									</ng-template>
								</td>

								<td class="viewBtnTd">
									<p-galleria [effect]="slide" [(value)]="featuredThisWeekData.photo"
										[(visible)]="featuredThisWeekData.bannerVisible" [responsiveOptions]="responsiveOptions"
										[containerStyle]="{'max-width': '850px'}" [numVisible]="7" [circular]="true"
										[fullScreen]="true" [showItemNavigators]="true" [showThumbnails]="false"
										[baseZIndex]="100000">
										<ng-template pTemplate="item" let-item>
											<img [src]="featuredThisWeekData.photo" style="width:100%; height:100%; display: block;" />
										</ng-template>
									</p-galleria>
									<button pButton *ngIf="featuredThisWeekData.photo.length > 0" type="button" icon="pi pi-eye" label="View" (click)="featuredThisWeekData.bannerVisible=true"></button>
								</td>
								<td class="col-200 YoutubeTD">
									<span>{{featuredThisWeekData.link}}</span>
								</td>
								<td class="col-150 statusTD">
										<div class="swichTable">
										
											<p-inputSwitch [(ngModel)]="featuredThisWeekData.status" (onChange)="changeStatus(featuredThisWeekData)">
											</p-inputSwitch>
										
											<div class="label activeText" *ngIf="featuredThisWeekData.status">
												Active
											</div>
										
											<div class="label InActiveText" *ngIf="!featuredThisWeekData.status">
												Inactive
											</div>
										
										</div>			</td>

								<td class="col-180 createdDateTD">
									{{featuredThisWeekData.created_at | date: 'dd/MM/yyyy'}}
								</td>

								<td class="col-180 CreatedByTD">
									{{featuredThisWeekData.createdBy}}
								</td>

								<td class="col-180 updatedTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
									{{featuredThisWeekData.updated_at | date: 'dd/MM/yyyy'}}
								</td>
								<td class="col-180 ModifiedbyTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
									{{featuredThisWeekData.updatedBy}}
								</td>

								<!-- <td class="col-180 actionTD"><span class="p-column-title">Action</span>
							<button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-4"
								(click)="onEditArticle(featuredThisWeekData)"></button>
							<button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning p-mr-4" (click)="onDelete(featuredThisWeekData)"></button>
						</td> -->
								<td class="text-nowrap p-element p-frozen-column" pfrozencolumn="" alignfrozen="right"
									style="width: 200px; right: 0px;">
									<ul class="actionList">
										<li>
											<button (click)="onEditFeaturedThisWeek(featuredThisWeekData) "
												class="editBtn"><img
													src="../../../assets/images/backend-image/common-images/editeBtn.svg"></button>
										</li>
										<li>
											<button (click)="onDelete(featuredThisWeekData)" class="deleteBtn"><img
													src="../../../assets/images/backend-image/common-images/deleteBtn.svg"></button>
										</li>
									</ul>

									<!-- <button pButton pRipple icon="pi pi-eye" class="p-button-rounded p-button-success p-mr-2" (click)="viewseller(seller.id)"></button> -->
									<!-- <button pButton pRipple icon="pi pi-pencil"
										class="p-button-rounded p-button-success p-mr-2"
										(click)="onEditFeaturedThisWeek(featuredThisWeekData)"></button>
									<button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-danger"
										(click)="onDelete(featuredThisWeekData)"></button> -->
								</td>
							</tr>
						</ng-template>
						<ng-template pTemplate="emptymessage">
							<tr>
								<td colspan="7">Featured this Week Management not found.</td>
							</tr>
						</ng-template>
					</p-table>
				</div>
			</div>
		</div>
	</div>
</div>

<p-confirmDialog [style]="{width:'400px'}" id="confirmDialog"></p-confirmDialog>